import { AGENT_DOCS } from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import AgentDocs from './index';
import AgentDocsThunk from './thunk';

const module: ModulesList = {
  [AGENT_DOCS]: {
    path: '/agentdocs',
    component: AgentDocs,
    thunk: AgentDocsThunk,
  } as Module,
};

export default module;
